import { useClient, useQuery } from '@weenat/client'
import { useIntl } from '@weenat/wintl'
import { useDefaultOrg } from 'app/orgProvider'
import { useNavigate, useSearchParams } from 'app/routx-router'
import Button from 'app/src/kit/Button'
import EmptyStateWithRipple from 'app/src/kit/empty-state/EmptyStateWithRipple'
import Icons from 'app/src/kit/Icons'
import Text from 'app/src/kit/Text'
import { useToken } from 'app/state'
import { isNil } from 'lodash-es'

export const Component = () => {
  const { t } = useIntl()
  const nav = useNavigate()
  const client = useClient()
  const token = useToken()
  const preferences = useQuery(client.preferences.get(), {
    refetchOnWindowFocus: true,
    enabled: !isNil(token)
  })
  const [params] = useSearchParams()
  const { org } = useDefaultOrg()
  return (
    <>
      <Text $fontSize='lg'>{t('auth.verification_success_title')}</Text>
      <div>
        <EmptyStateWithRipple
          tint={'feedback.success.500'}
          Icon={Icons.CheckCircle}
          title={t('auth.verification_success_description_title')}
          description={!isNil(org) ? t('auth.verification_success_description') : undefined}
        >
          <Button
            onPress={() => {
              const shouldGoToOnboarding =
                !isNil(org) && (preferences.data?.onboardingContext?.shouldShowOnboarding ?? false)
              if (shouldGoToOnboarding) {
                nav(`/farms/${org.id}/onboarding`, {
                  search: {
                    ...(params as Record<string, string>),
                    ...preferences.data?.onboardingContext?.search
                  }
                })
              } else {
                nav('/', { replace: true })
              }
            }}
          >
            {t(!isNil(org) ? 'actions.next' : 'actions.close')}
          </Button>
        </EmptyStateWithRipple>
      </div>
    </>
  )
}
export default Component
